import { Component } from "@angular/core";
import { StockChart } from "angular-highcharts";
import * as Highcharts from "highcharts";
import { ChartService } from "../../../widget-utilities/chart.service";
import { multiColorThemes } from "../../common/chartThemes";
import { BaseChartComponent } from "../base/basechart.component";

@Component({
    selector: 'app-linechart',
    templateUrl: './linechart.component.html',
    styleUrls: ['../base/basechart.component.scss'],
    standalone: false
})

export class LinechartComponent extends BaseChartComponent {
    constructor(protected chartService: ChartService) {
      super(chartService)
    }

    createChart(): void {
        if (this.data) {
            const colorScheme = this.colorSchemeId;
            const theme: Highcharts.Options = multiColorThemes[colorScheme !== null ? colorScheme : 0];
            const isCalls = this.isCalls;

            let generatedChartData = this.chartService.generateChartData(this.data, "spline", isCalls);
            let initChart = this.chartService.createChart(
                this.gridItem, generatedChartData.categories, generatedChartData.series, generatedChartData.props, this.type, theme, isCalls);
            this.chart = new StockChart({
                ...initChart,
                chart: {
                    events: {
                        load: function () {
                            Highcharts.addEvent(this.tooltip, 'headerFormatter', function (e: any) {
                                if (!e.isFooter) {
                                    e.text = generatedChartData.categories[e.labelConfig.x];
                                }

                                if (isCalls) {
                                    e.text = "";
                                }
                            });
                        }
                    },
                    ...theme.chart,
                    ...theme
                }
            });
        }
    }
}
